// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rrE2","type":"styles_type__1r16y","choices":"styles_choices__2ZQcN"};